// src/components/Settings.js
import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import AudioManager from '../audio/AudioManager';

const Settings = ({ show, onHide }) => {
  const [settings, setSettings] = useState(AudioManager.settings);

  const handleChange = (setting, value) => {
	const newSettings = { ...settings, [setting]: value };
	setSettings(newSettings);
	AudioManager.updateSettings(newSettings);

	// If enabling music, start playing immediately
	if (setting === 'musicEnabled' && value === true) {
	  AudioManager.playBackgroundMusic();
	}
  };

  return (
	<Modal 
	  show={show} 
	  onHide={onHide}
	  centered
	  className="settings-modal"
	>
	  <Modal.Header closeButton>
		<Modal.Title>Settings</Modal.Title>
	  </Modal.Header>
	  <Modal.Body>
		<Form>
		  <div className="mb-4">
			<h5>Music</h5>
			<Form.Check
			  type="switch"
			  id="music-toggle"
			  label="Enable Background Music"
			  checked={settings.musicEnabled}
			  onChange={(e) => handleChange('musicEnabled', e.target.checked)}
			  className="mb-2"
			/>
			<Form.Label>Music Volume</Form.Label>
			<Form.Range
			  value={settings.musicVolume * 100}
			  onChange={(e) => handleChange('musicVolume', e.target.value / 100)}
			  disabled={!settings.musicEnabled}
			/>
		  </div>

		  <div className="mb-4">
			<h5>Sound Effects</h5>
			<Form.Check
			  type="switch"
			  id="sound-toggle"
			  label="Enable Sound Effects"
			  checked={settings.soundEnabled}
			  onChange={(e) => handleChange('soundEnabled', e.target.checked)}
			  className="mb-2"
			/>
			<Form.Label>Sound Effects Volume</Form.Label>
			<Form.Range
			  value={settings.soundVolume * 100}
			  onChange={(e) => handleChange('soundVolume', e.target.value / 100)}
			  disabled={!settings.soundEnabled}
			/>
		  </div>
		</Form>
	  </Modal.Body>
	  <Modal.Footer>
		<Button variant="secondary" onClick={onHide}>
		  Close
		</Button>
	  </Modal.Footer>
	</Modal>
  );
};

export default Settings;